
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import { VTooltip } from 'v-tooltip';
import './tooltip-mixin.js';

VTooltip.options.defaultClass = 'pendo-tooltip';
VTooltip.options.defaultBoundariesElement = 'viewport';
VTooltip.options.defaultHtml = false;

const bind = function (unboundFn) {
  return function (el, {
    value
  }) {
    if (typeof value !== 'object') {
      return unboundFn(...arguments);
    }

    const theme = value.theme,
          arrow = value.arrow,
          classes = value.classes,
          multiline = value.multiline,
          offset = value.offset;

    if (offset == null) {
      value.offset = 8;
    }

    value.classes = `pendo-tooltip ${typeof value.classes === 'string' ? value.classes : ''}`;

    if (Array.isArray(classes)) {
      classes.forEach(cls => {
        value.classes += ` ${cls}`;
      });
    }

    if (multiline) {
      value.classes += ' is-multi-line';
    }

    if (arrow) {
      value.classes += ' has-tooltip-arrow';
    }

    if (theme) {
      value.classes += ` pendo-tooltip--${theme}`;
    }

    if (value.disposeTimeout) {
      VTooltip.options.disposeTimeout = disposeTimeout;
    } else {
      VTooltip.options.disposeTimeout = 2000;
    }

    return unboundFn(...arguments);
  };
}(VTooltip.bind);

const PendoTooltip = _objectSpread({}, VTooltip, {
  bind,
  update: bind
});

export default PendoTooltip;
export { PendoTooltip };
